import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%"} }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("iframe", {
      style: {"width":"100%","height":"100%"},
      src: 'https://paletteiot.kb.japaneast.azure.elastic-cloud.com/s/'+ this.$route.params.space +'/app/dashboards#/'
    }, null, 8, _hoisted_2), [
      [_vShow, _ctx.isShowIFrame]
    ]),
    _hoisted_3,
    _withDirectives(_createElementVNode("button", {
      class: "btn btn-dark",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openKibanaWindow && _ctx.openKibanaWindow(...args)))
    }, " 別のウィンドウでKibanaを開く ", 512), [
      [_vShow, !_ctx.isShowIFrame]
    ])
  ]))
}